$(function () {
    $('.date-time-sec-picker').each(function () {
        var current = $(this);
        var locale = $.extend(true, {}, daterangepickerLocale, {
            format: 'DD/MM/YYYY HH:mm:ss'
        });
        current.daterangepicker({
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 1,
            timePickerSeconds: true,
            singleDatePicker: true,
            autoUpdateInput: false,
            showDropdowns: true,
            locale: locale
        }, function(start, end, label) {
            $('#' + current.data('field')).val(start.format('DD/MM/YYYY HH:mm:ss'));
            current.val(start.format('DD/MM/YYYY HH:mm:ss'));
        });
    });

    $('.date-time-sec-range-picker').each(function () {
        var current = $(this);
        var locale = $.extend(true, {}, daterangepickerLocale, {
            format: 'DD/MM/YYYY HH:mm:ss'
        });
        var start_date = $('#' + current.attr('id') + '_start').val();
        var end_date = $('#' + current.attr('id') + '_end').val();

        var options = {
            timePicker: true,
            timePicker24Hour: true,
            timePickerIncrement: 1,
            timePickerSeconds: true,
            showDropdowns: true,
            autoUpdateInput: true,
            showWeekNumbers: true,
            linkedCalendars: false,
            alwaysShowCalendars: true,
            locale: locale
        };

        if(start_date && end_date) {
            options.startDate =start_date;
            options.endDate = end_date;
        }

        current.daterangepicker(options , function(start, end, label) {
            $('#' + current.attr('id') + '_start').val(start.format('DD/MM/YYYY HH:mm:ss'));
            $('#' + current.attr('id') + '_end').val(end.format('DD/MM/YYYY HH:mm:ss'));
        });
    });
});



// WEBPACK FOOTER //
// ./resources/js/app/_global.js